module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "recphd",
    attrs: {
      "id": "c03_sec2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#c03_sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collard Green Salad "), _c('em', [_vm._v("with")]), _vm._v(" Coconut Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "graphic"
  }, [_c('img', {
    staticStyle: {
      "height": "60vh"
    },
    attrs: {
      "alt": "images",
      "src": "OEBPS/images/31-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "serv"
  }, [_c('em', [_vm._v("4 to 6 servings")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('strong', [_vm._v("PREP TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('em', [_vm._v("8 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('strong', [_vm._v("COOKING TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('em', [_vm._v("5 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('strong', [_vm._v("TOTAL TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('em', [_vm._v("13 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "nont"
  }, [_vm._v("3 cups shredded collard greens")]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("1 red onion, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("1 English cucumber, peel left on, sliced into half-moon shapes")]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("about ¼ cup "), _c('a', {
    attrs: {
      "href": "#/OEBPS/c03_sec2#page32"
    }
  }, [_vm._v("Coconut Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("kosher salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("¼ cup "), _c('span', {
    attrs: {
      "href": "#/OEBPS/c12_sec10#page188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adzuki Red Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "nonb"
  }, [_vm._v("¼ cup candied cashews")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Every few months, some food magazine or blog pops up the same tired headline: “Are Collard Greens the New Kale?” No. Collards have worked harder than kale ever will. Collards are out there digging ditches and roofing houses while kale goes to spin class and leaves early for brunch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Collards are natural antioxidants, rich in vitamins A, C, and K, full of fiber and low in calories. But—and this is a big one— collards have a long history of being a vegetable that people only cook the crap out of. They’re braised and simmered within an inch of being edible and, well, that’s got to stop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our friends always eat this dish and say, “Isn’t this a kale salad?” The goal is to serve the greens raw so that we think of them as something healthy and delicious rather than something you combine with bacon fat and cook down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Collards have a natural bitterness, and the elements of this recipe balance those strong flavors with sweetness and spice: sweetness in the coconut milk, spice in the smoky chipotle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s a brightness to the dressing that perfectly balances the bitterness of the collards and will give your guests the benefit of enjoying everything collards have to offer. To me, this dish is simplicity done well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a large bowl, toss the greens with the onion and cucumber with just enough dressing to coat and season to taste with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Top the salad with the beans and candied cashews.")]), _vm._v(" "), _c('h2', {
    staticClass: "recphd1",
    attrs: {
      "id": "c03_secc3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }), _vm._v("COCONUT DRESSING")]), _vm._v(" "), _c('p', {
    staticClass: "serv"
  }, [_c('em', [_vm._v("Makes about 2 cups")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('strong', [_vm._v("PREP TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('em', [_vm._v("8 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('strong', [_vm._v("COOKING TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('em', [_vm._v("5 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('strong', [_vm._v("TOTAL TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "serv1"
  }, [_c('em', [_vm._v("13 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "nont"
  }, [_vm._v("1 tablespoon cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("1 teaspoon minced fresh ginger")]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("2 shallots, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("¼ cup canned chipotles in adobo")]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("1 cup coconut milk")]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("¼ cup fresh lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "non"
  }, [_vm._v("¼ cup Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "nonb"
  }, [_vm._v("3 tablespoons champagne vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Put the cumin seeds in a small dry sauté pan. Toast over medium heat until fragrant, 3 to 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combine the toasted cumin seeds with the remaining ingredients in a blender and blend until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Store in a covered nonreactive container. Refrigerate for up to 3 weeks.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f1cd168","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c03_sec2.vue
// module id = 90
// module chunks = 0